var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-white d-flex flex-column justify-content-between h-full",
      attrs: { flat: "" },
    },
    [
      _vm.isLoading
        ? _vm._l(Array.from(Array(10).keys()), function (item, index) {
            return _c("v-skeleton-loader", {
              key: index,
              ref: "skeleton",
              refInFor: true,
              staticClass: "mx-auto",
              attrs: { type: "list-item-avatar-three-line" },
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.questions.length > 0
        ? [
            _c(
              "ul",
              { staticClass: "thread-list", staticStyle: { height: "90%" } },
              [
                _vm._l(_vm.questions, function (question) {
                  return _c(
                    "v-list-item",
                    {
                      key: question.id,
                      staticClass: "ps-0",
                      on: {
                        click: function ($event) {
                          return _vm.onQuestionClick(question)
                        },
                      },
                    },
                    [
                      _c("v-list-item-icon", { staticClass: "me-5" }, [
                        _c("div", { staticClass: "question-box" }, [
                          _c("div", { staticClass: "question-num" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(question.answersCount) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "question-active": question.answersCount > 0,
                                "question-deactive": question.answersCount == 0,
                              },
                            },
                            [_vm._v("\n              Ans\n            ")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            domProps: { textContent: _vm._s(question.title) },
                          }),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            question.createdAt
                              ? _c("span", { staticClass: "me-2" }, [
                                  _vm._v(
                                    _vm._s(question.createdAt.substring(0, 10))
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "me-2" },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("thumb_up"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(question.voteValues) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            question.user && question.user.image
                              ? _c("img", {
                                  staticStyle: { width: "15px" },
                                  attrs: { src: question.user.image.url },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            question.user && question.user.name
                              ? _c("span", [_vm._v(_vm._s(question.user.name))])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.pagination.totalPages > 1
                  ? _c("v-pagination", {
                      staticClass: "mt-4 mb-5 pb-5",
                      attrs: { length: _vm.pagination.totalPages },
                      on: { input: _vm.selectPage },
                      model: {
                        value: _vm.pagination.page,
                        callback: function ($$v) {
                          _vm.$set(_vm.pagination, "page", $$v)
                        },
                        expression: "pagination.page",
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.questions.length == 0
        ? _c("p", { staticClass: "mt-2", staticStyle: { color: "#666666" } }, [
            _vm._v("質問はまだありません。"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }